var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"950px"},model:{value:(_vm.isVisibleDialog),callback:function ($$v) {_vm.isVisibleDialog=$$v},expression:"isVisibleDialog"}},[_c('routes-form',{attrs:{"type":"edit","read-only":false,"item":_vm.item,"loading":_vm.isLoading},on:{"onclose":_vm.closeForm,"onsave":_vm.updateItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }